import styled, { keyframes, css } from 'styled-components';
import { LoadingCircleProps } from './LoadingCircle';

export const spinAnimation = (defaultValue: number) => keyframes`
  0% {
    stroke-dashoffset: 0;
  }
  100% {
    stroke-dashoffset: calc(3.14px * ${defaultValue * 2});
  }
`;

export const circleWrapAnimation = () => keyframes`
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(-360deg);
  }
  100% {
    transform: rotate(-720deg);
  }
`;

/**
 * example
 */
export const LoadingCircleWrapStyle = css`
  height: 100%;
  animation: 1.5s ${circleWrapAnimation()} infinite linear;
`;

export const LoadingCircleStyle = css`
  stroke-width: 2px;
  r: calc(30px / 2 - (2px / 2));
  stroke-dasharray: calc(3.14 * (2 * (30px / 2 - (2px / 2))));
  animation: 1.5s ${spinAnimation(2 * (30 / 2 - 2 / 2))} infinite ease-in-out;
`;

export const LoadingCircleWrap = styled.svg<
  Pick<LoadingCircleProps, 'wrapCss'>
>`
  position: relative;
  z-index: 2;

  ${LoadingCircleWrapStyle}
  ${(props) => props.wrapCss}
`;

export const LoadingCircle = styled.circle<
  Pick<LoadingCircleProps, 'circleCss'>
>`
  cx: 50%;
  cy: 50%;
  fill: transparent;
  stroke: ${(props) => props.theme.color.mainTheme};
  stroke-width: 4px;
  transform-origin: 50%;

  ${LoadingCircleStyle}
  ${(props) => props.circleCss}
`;
